import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/main.scss'
import http from './api/http.js'
Vue.http = Vue.prototype.$http = http
Vue.config.productionTip = false

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import VScaleScreen from 'v-scale-screen'
Vue.use(VScaleScreen)
import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API
import {
  Select,
  Option,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Input,
  Descriptions,
  DescriptionsItem,
  Tag,
  Divider,
  Collapse,
  CollapseItem,
  Button,
  Avatar,
  Carousel,
  CarouselItem,
  Table,
  TableColumn,
  Image,
  Progress,
  DatePicker,
  Dialog,
  Upload,
  Checkbox,
  CheckboxGroup,
  Loading,
  Alert,
  Radio,
  RadioGroup,
  Step,
  Steps,
  Drawer,
} from 'element-ui'
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Button)
Vue.use(Avatar)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Image)
Vue.use(Progress)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Loading)
Vue.use(Alert)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Drawer)
// 将页面导出pdf
import htmlToPdf from '@/assets/js/htmlToPdf.js'
Vue.use(htmlToPdf)
console.log = () => {}
window._AMapSecurityConfig = {
  serviceHost: 'http://10.66.22.123:8080/app/_AMapService',
}
Vue.prototype.$EventBus = new Vue()
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
